import React from 'react'
import { ProfilePageWrapper } from '../../components/ProfilePageComponents'
import { PlayListPageContent } from '../../components/ProfilePageComponents/ui/SharedPlaylistComponents/PlayListPageContent'

export const SharedPlaylistPage = () => (
  <ProfilePageWrapper>
    <PlayListPageContent />
  </ProfilePageWrapper>
)
